<template>
 <router-view/>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style>
body{
  padding: 0;
  margin: 0 !important;
  cursor: url(https://blog-static.cnblogs.com/files/laoguantongxiegogo/pointer_24px_1231389_easyicon.net.ico), auto;
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
  background-color: #f5f7fa;
  color: #333;
  font-size: 16px;
}
html{
  font-size: 12px;
  background-color: #f5f5f5;
  //overflow: hidden;
}

::-webkit-scrollbar{
  display: none;
}
</style>
